/* TØTE cart drawer v3, upsell carousel (agent build 2026-10-24). Owner: build/drawer-v3-2026-10-24/README.md
   - html.tt-cd3 switches the v3 carousel on. The Intelligems arm sets it; ?ttCd=1 / ?ttCd=0 sets or clears
     it for QA for the rest of the browser session (never reported to Intelligems).
   - "Free shipping" tags: shown when total < round(EUR threshold x Shopify.currency.rate) <= total after
     adding, the same conversion the legacy shipping bar uses (assets/cart.js), so both agree in every currency.
   - [data-tt-cd3-add] adds one unit with property _tt_cd3 so carousel adds can be counted on orders, then
     re-renders the drawer through the theme's own cart-drawer element. */
(function () {
  'use strict';
  if (window.__ttCd3) return;
  window.__ttCd3 = true;

  (function qa() {
    var m = /[?&]ttCd=([01])\b/.exec(window.location.search);
    var v = null;
    try {
      if (m) window.sessionStorage.setItem('ttCd3', m[1]);
      v = window.sessionStorage.getItem('ttCd3');
    } catch (e) { v = m ? m[1] : null; }
    if (v === '1') document.documentElement.classList.add('tt-cd3');
    else if (v === '0') document.documentElement.classList.remove('tt-cd3');
  })();

  function drawer() { return document.querySelector('cart-drawer'); }

  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return r > 0 ? r : 1;
  }

  /* Intelligems price test (e.g. the SIV 59 / 54 / 49 test): Liquid prints Shopify's price, which is the
     highest arm. igData.price.getPriceByVariantId returns the visitor's arm price in currency units for a
     product in a running test, null otherwise (measured 2026-10-24). Cards carrying data-tt-fixed show a
     set or pair price the discount charges and are left alone. */
  function igPrices() {
    var ig = window.igData && window.igData.price;
    if (!ig || typeof ig.getPriceByVariantId !== 'function') return false;
    Array.prototype.forEach.call(document.querySelectorAll('.tt-cd3-card[data-tt-v]:not([data-tt-fixed])'), function (card) {
      var p, c;
      try { p = ig.getPriceByVariantId(card.getAttribute('data-tt-v')); c = ig.getComparePriceByVariantId(card.getAttribute('data-tt-v')); } catch (e) { return; }
      if (p == null || p === '' || isNaN(parseFloat(p))) return;
      var cents = Math.round(parseFloat(p) * 100);
      if (String(cents) === card.getAttribute('data-tt-now')) return;
      var fmt = function (x) { var n = x / 100; return n % 1 ? n.toFixed(2) : String(n); };
      var span = card.querySelector('[data-tt-price]');
      if (span) span.textContent = span.textContent.replace(/\d[\d.,]*/, fmt(cents));
      var was = card.querySelector('[data-tt-was]');
      var cc = c != null && !isNaN(parseFloat(c)) ? Math.round(parseFloat(c) * 100) : 0;
      if (was && cc > cents) was.textContent = was.textContent.replace(/\d[\d.,]*/, fmt(cc));
      var rail = card.closest('[data-tt-rail]');
      var total = rail ? parseFloat(rail.getAttribute('data-total')) || 0 : 0;
      var ship = card.querySelector('[data-tt-ship]');
      if (ship) ship.setAttribute('data-after', String(total + cents));
      card.setAttribute('data-tt-now', String(cents));
    });
    return true;
  }

  /* Set and pair prices OUTSIDE EUR (2026-10-25). They are charged by our own discount function,
     apps/tote-pricing (Kopstorm's only discounts EUR), which converts a EUR set price the way Shopify
     converts every product price: rate x price, rounded UP to a whole unit (HUF to 100). This mirrors that
     code exactly, including the currency table: a currency missing here or there shows the normal price.
     🛑 LOCAL_SET stays false until that discount is LIVE and a checkout has been seen charging what the
     card shows; a card must never promise a price checkout does not honour.
     ✅ Switched on 2026-10-25 ~10:15 UTC on Hajo's word: automatic discount live 10:12:42 UTC, and a test code
     on the same function charged exactly these numbers in SEK, GBP, CHF, HUF, DKK and PLN carts. */
  var LOCAL_SET = true;
  var ROUNDING_MINOR = { GBP: 100, CHF: 100, SEK: 100, DKK: 100, PLN: 100, CZK: 100, HUF: 10000, USD: 100 };
  var TOTE_PAIR_UNIT_EUR = 3500;

  function localOf(eurMinor, rate, inc) { return Math.ceil(eurMinor * rate / inc - 1e-9) * inc; }

  function fmtLike(text, minor) {
    // Rewrite the number inside an existing money string ("390 kr", "£30", "13 100 Ft"), keeping its
    // symbol, spacing and thousands separator. Set and pair prices are whole units, so no decimals.
    var m = /\d{1,3}(?:([.,\s  ])\d{3})*(?:[.,]\d{1,2})?/.exec(text);
    if (!m) return text;
    var sep = m[1] || '';
    var whole = String(Math.round(minor / 100));
    if (sep) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return text.slice(0, m.index) + whole + text.slice(m.index + m[0].length);
  }

  function localSet() {
    if (!LOCAL_SET) return;
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    var inc = ROUNDING_MINOR[cur];
    var r = rate();
    if (!inc || !(r > 0)) return;
    Array.prototype.forEach.call(document.querySelectorAll('.tt-cd3-card[data-tt-set-eur]:not([data-tt-local]), .tt-cd3-card[data-tt-pair-other]:not([data-tt-local])'), function (card) {
      card.setAttribute('data-tt-local', '1');
      var price = parseInt(card.getAttribute('data-tt-now'), 10) || 0;
      var target = 0, tagKey = '';
      if (card.hasAttribute('data-tt-set-eur')) {
        target = localOf(parseInt(card.getAttribute('data-tt-set-eur'), 10) || 0, r, inc);
        tagKey = 'data-tag-set';
      } else {
        target = 2 * localOf(TOTE_PAIR_UNIT_EUR, r, inc) - (parseInt(card.getAttribute('data-tt-pair-other'), 10) || 0);
        tagKey = 'data-tag-pair';
      }
      // A pair price equal to the card's own price still gets the tag (Liquid does the same in EUR); a set
      // price must be a real saving.
      var isPair = tagKey === 'data-tag-pair';
      if (!(target > 0 && (target < price || (isPair && target === price)))) return;
      var span = card.querySelector('[data-tt-price]');
      var priceP = card.querySelector('.tt-cd3-card__price');
      if (!span || !priceP) return;
      if (target < price) {
        var oldText = span.textContent;
        var was = card.querySelector('[data-tt-was]');
        if (!was) {
          was = document.createElement('s');
          was.setAttribute('data-tt-was', '');
          priceP.insertBefore(document.createTextNode(' '), span);
          priceP.insertBefore(was, priceP.firstChild);
        }
        was.textContent = oldText;
        span.textContent = fmtLike(oldText, target);
      }
      var rail = card.closest('[data-tt-rail]');
      var label = rail && rail.getAttribute(tagKey);
      var tags = card.querySelector('.tt-cd3-card__tags');
      if (label && tags && !tags.querySelector('.tt-cd3-tag:not(.tt-cd3-tag--ship)')) {
        var t = document.createElement('span');
        t.className = 'tt-cd3-tag';
        t.textContent = label;
        tags.insertBefore(t, tags.firstChild);
      }
      var total = rail ? parseFloat(rail.getAttribute('data-total')) || 0 : 0;
      var ship = card.querySelector('[data-tt-ship]');
      if (ship) ship.setAttribute('data-after', String(total + target));
      card.setAttribute('data-tt-now', String(target));
      card.setAttribute('data-tt-fixed', '');
      if (!isPair) {
        var note = document.querySelector('.tt-cd3-rail--acc [data-tt-set-note]');
        if (note) note.hidden = false;
      }
    });
  }

  function shipTags() {
    initSwipers();
    localSet();
    igPrices();
    Array.prototype.forEach.call(document.querySelectorAll('[data-tt-rail]'), function (rail) {
      var thr = Math.round((parseFloat(rail.getAttribute('data-thr')) || 0) * rate());
      var total = parseFloat(rail.getAttribute('data-total')) || 0;
      Array.prototype.forEach.call(rail.querySelectorAll('[data-tt-ship]'), function (tag) {
        var after = parseFloat(tag.getAttribute('data-after')) || 0;
        tag.hidden = !(thr > 0 && total < thr && after >= thr);
      });
    });
  }

  function add(id, btn) {
    var d = drawer();
    var body = { items: [{ id: Number(id), quantity: 1, properties: { _tt_cd3: 'drawer' } }] };
    if (d && d.getSectionsToRender) {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.classList.add('is-loading');
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && !res.status && d && d.renderContents && res.sections) {
        d.renderContents(res);
        d.classList.remove('is-empty');
      }
      shipTags();
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
      });
    }).catch(function () {}).then(function () { btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-tt-cd3-add]');
    if (a) {
      e.preventDefault();
      if (!a.classList.contains('is-loading')) add(a.getAttribute('data-tt-cd3-add'), a);
      return;
    }
    var s = e.target.closest('[data-tt-scroll]');
    if (s) {
      e.preventDefault();
      var rail = s.closest('[data-tt-rail]');
      var track = rail && rail.querySelector('[data-tt-track]');
      // With Swiper running its navigation moves the row; scrolling the hidden overflow as well would move it
      // twice. This branch is the native fallback only.
      if (track && !track.swiper) track.scrollBy({ left: parseInt(s.getAttribute('data-tt-scroll'), 10) * track.clientWidth * 0.8, behavior: 'smooth' });
    }
  });

  /* Desktop: drag a row with the mouse, as on Dore & Rose (Hajo 2026-10-25: "je kan niet door scrollen").
     A mouse wheel only scrolls vertically and dragging a photo started an image drag, so on a computer only
     the arrows moved the row. Mouse only: touch keeps the browser's own swipe, measured working. A drag of
     more than 5px swallows the click that follows, so letting go never opens a product. */
  var drag = null;
  var swallowClick = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest && e.target.closest('[data-tt-track]');
    if (!track || track.swiper || e.target.closest('[data-tt-cd3-add]')) return; // Swiper drags its own rows
    drag = { track: track, x: e.clientX, left: track.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.track.classList.add('is-dragging');
    }
    if (drag.moved) {
      e.preventDefault();
      drag.track.scrollLeft = drag.left - dx;
    }
  });
  function endDrag() {
    if (!drag) return;
    if (drag.moved) {
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 0);
    }
    drag.track.classList.remove('is-dragging');
    drag = null;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('click', function (e) {
    if (swallowClick && e.target.closest && e.target.closest('[data-tt-track]')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('[data-tt-track]')) e.preventDefault();
  });

  /* Rows as Swiper carousels (2026-10-25, Hajo: "je kan niet door scrollen", desktop and mobile). The theme
     loads swiper-bundle on every page (checked: home, collection, product, crossbody page). Swiper swipes in
     JavaScript, so it does not depend on Safari scrolling a sideways strip nested inside the drawer's own
     vertical scroll. Free mode with momentum feels like a native flick; Swiper's grab cursor gives the mouse
     drag on desktop; the rail's own arrows are its navigation. Without Swiper the native strip remains. */
  function initSwipers() {
    if (typeof window.Swiper !== 'function') return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-tt-track]'), function (el) {
      if (el.swiper || el.querySelectorAll('.swiper-slide').length < 2) return;
      var rail = el.closest('[data-tt-rail]');
      el.scrollLeft = 0;
      try {
        new window.Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: { enabled: true, momentum: true, momentumRatio: 0.85 },
          grabCursor: true,
          simulateTouch: true,
          touchStartPreventDefault: false,
          passiveListeners: true,
          resistanceRatio: 0.85,
          preventClicks: true,
          preventClicksPropagation: true,
          touchReleaseOnEdges: true,
          watchOverflow: true,
          // Trackpad: a two-finger sideways swipe moves the row (Hajo 2026-10-25: click-and-drag alone was
          // annoying). forceToAxis keeps an up/down swipe scrolling the drawer, releaseOnEdges hands it back at the ends.
          mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: 1 },
          navigation: rail ? { prevEl: rail.querySelector('[data-tt-scroll="-1"]'), nextEl: rail.querySelector('[data-tt-scroll="1"]') } : undefined
        });
      } catch (err) { /* leave the native strip in place */ }
    });
  }

  function watch() {
    shipTags();
    var d = drawer();
    if (d && window.MutationObserver) new MutationObserver(shipTags).observe(d, { childList: true, subtree: true });
  }
  document.addEventListener('cart:change', function () { setTimeout(shipTags, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  /* Intelligems loads async; re-apply its prices once it is there. */
  [800, 2500, 6000].forEach(function (t) { setTimeout(shipTags, t); });
})();
